<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Factory" class="d-icon d-icon--factory" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M.94.94A1.5 1.5 0 0 1 2 .5h1A1.5 1.5 0 0 1 4.5 2v3.528l2.71-1.935A.5.5 0 0 1 8 4v1.528l2.71-1.935A.5.5 0 0 1 11.5 4v6a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 10V2c0-.398.158-.78.44-1.06ZM2 1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4.972L7.79 6.907A.5.5 0 0 1 7 6.5V4.972L4.29 6.907A.5.5 0 0 1 3.5 6.5V2a.5.5 0 0 0-.5-.5H2ZM3 9a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 3 9Zm2.5 0a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5ZM8 9a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 8 9Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFactory',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
